<template>
    <div id="app">
        <div class="logo mt-3 text-center">
            <img class="img-responsive wthirty" src="/images/logo.png" alt="INFAOP"/>
            <h1 v-if="!isComplete">Iscriviti ai nostri corsi</h1>
            <h4 v-if="!isComplete">Compila il modulo qui di seguito per essere contattato da un nostro operatore</h4>
        </div>
        <form-config-provider v-show="!isLoading"/>
        <div class="loading" v-if="isLoading">
            Invio in corso ...
        </div>
    </div>
</template>

<script>
import FormConfigProvider from "./components/FormConfigProvider.vue"

export default {
    name: "app",
    components: {
        FormConfigProvider
    },
    data() {
        return {

            isComplete: false,
            isLoading: false
        }
    },
    methods: {
        formAggiornato(event) {
            this.isComplete = event
        },
        formInvia(event) {
            console.log('qualcuno chiede di inviare!', event, this.$store.state.lead.formData, window.Laravel);
            let data = this.$store.state.lead.formData;
            data._token = window.Laravel.csrfToken;
            this.$isLoading(true);
            this.isLoading = true;
            console.log('sending data', data);
            window.axios.post(window.Laravel.prefix + "/extapi/studentsubscribe", data).then((r) => {
                console.log('verifica risposta', r);
                if (r.data && r.data.success) {
                    toastr.success('La tua preiscrizione è stata inserita con successo, controlla la tua email', 'Ottimo!');
                    setTimeout(function() {
                        document.location = "https://www.infaop.com";
                    },400);
                    return true;
                }
                toastr.warning('Si è verificato qualche errore, riprova più tardi.', 'Attenzione');
                return false;
            }).catch((error) => {
                console.log('Errori ....', error.response.data);
                if (error.response.data && error.response.data.errors) {
                    console.log('mostra toastr',error.response.data.errors);
                    let objValues = Object.values(error.response.data.errors);
                    toastr.error(
                        objValues.join("<br/>")
                        , 'Errore'
                    );
                } else {
                    toastr.error('Si è verificato qualche errore, riprova più tardi.', 'Attenzione');

                }
                return false;
            }).finally((reso) => {
                console.log('fine di tutto', reso);
                this.$isLoading(false);
                this.isLoading = (false);
            });

        }
    },
    mounted() {
        this.$root.$on('formCompletitionChanged', this.formAggiornato);
        this.$root.$on('sendForm', this.formInvia);
    }
}
</script>
<style>
@import url("https://cdn.jsdelivr.net/npm/animate.css@3.5.1");
</style>
